module.exports = __webpack_public_path__ + "static/harvard-2a47fa2568feb9bd95bf14f1168ece93.png";